import classnames from 'classnames'
import Image from 'next/image'
import { ClockIcon, FileTextFilledIcon } from '@icons'
import { Tag, Link } from '@platform/ui-kit'

import styles from './index.module.scss'

type StaticImageData = {
  src: string
  height: number
  width: number
  placeholder?: string
}

export type ArticleCardProps = {
  className?: string
  picture?: string | StaticImageData | null
  tag?: string | null
  title: string
  description: string
  minutesRead: number
  href: string
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
}

export const ArticleCard = ({
  className,
  picture,
  title,
  description,
  minutesRead,
  tag,
  href,
  as = 'p',
}: ArticleCardProps) => {
  const CustomArticleTitleTag = `${as}` as keyof JSX.IntrinsicElements

  return (
    <div className={classnames(styles['article-card'], className)}>
      <div className={styles['picture-wrapper']}>
        {picture ? (
          <Image
            className={styles['picture']}
            src={picture}
            alt={`The ${title}'s article card`}
            priority
            fill
            sizes="100vw"
          />
        ) : (
          <FileTextFilledIcon className={styles['picture-icon']} />
        )}
      </div>
      <div className={styles['text-wrapper']}>
        <div
          className={classnames(styles['time-read-container'], {
            [styles['container-with-tag']]: tag,
          })}
        >
          {tag && <Tag label={tag} className={styles['article-tag']} />}
          {tag && <Tag label={tag} size="small" className={styles['article-tag-small']} />}
          <p className={styles['min-read']}>
            <ClockIcon className={styles['clock-icon']} />
            <span>{minutesRead} min read</span>
          </p>
        </div>
        <CustomArticleTitleTag className={styles['title']} title={title}>
          {title}
        </CustomArticleTitleTag>
        <p className={styles['description']} title={description}>
          {description}
        </p>
      </div>
      <Link href={href} className={styles['clickable-area']} aria-label={title} prefetch={false} />
    </div>
  )
}

export default ArticleCard
